/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { OccupationalInsuranceAssociationCustomerInfoControllerService } from './services/occupational-insurance-association-customer-info-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    OccupationalInsuranceAssociationCustomerInfoControllerService,
    ApiConfiguration
  ],
})
export class CustomersInsuranceModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersInsuranceModule> {
    return {
      ngModule: CustomersInsuranceModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersInsuranceModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersInsuranceModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
